import React from "react";
import Signup from ".";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { GOOGLE_CAPTCHA_SITE_KEY_V3 } from "../../utils/constants/appConstants";

const SignupWithRecaptcha = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={GOOGLE_CAPTCHA_SITE_KEY_V3}
      scriptProps={{ async: true, defer: true, appendTo: "head" }}
    >
      <Signup />
    </GoogleReCaptchaProvider>
  );
};

export default SignupWithRecaptcha;
